//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.BaseEvaluatorBuilder.js";
let d=[[[0,"AspectSelection",1,0],[0,"DepthCriteria",1,0],[0,"NumLevels",1,0],[0,"TypeSelection",1,0]],[[[],"GetFilterObjectsBuilder",{R_:{filterBuilder:"AME.FilterObjectsBuilder"}},0,0]],[]];
SPLM.AME.PlcSymbolsEvaluatorBuilder = class extends SPLM.AME.BaseEvaluatorBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.PlcSymbolsEvaluatorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.PlcSymbolsEvaluatorBuilder.FilterType = Object.freeze({
    "Tags" : "Tags", "Idbs" : "Idbs", "FunctionBlocks" : "FunctionBlocks", "Functions" : "Functions", "PageMacros" : "PageMacros", "WindowMacros" : "WindowMacros", "CallerInstance" : "CallerInstance", "All" : "All", "LocalVariable" : "LocalVariable", "Methods" : "Methods", "LocalModules" : "LocalModules", "PlcDataTypes" : "PlcDataTypes"});

SPLM.AME.PlcSymbolsEvaluatorBuilder.SearchCriteriaByHierarchy = Object.freeze({
    "All" : "All", "Levels" : "Levels"});

export default SPLM;